export const authenticationConstants = {
  SET_STATE_AUTH: "SET_STATE_AUTH",

  GET_PROFILE_INFO: "GET_PROFILE_INFO",
  GET_PROFILE_INFO_PENDING: "GET_PROFILE_INFO_PENDING",
  GET_PROFILE_INFO_FULFILLED: "GET_PROFILE_INFO_FULFILLED",
  GET_PROFILE_INFO_FAILURE: "GET_PROFILE_INFO_FAILURE",

  LOGIN: "LOGIN",
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  LOGIN_ERROR: "USERS_LOGIN_ERROR",

  LOGOUT: "USERS_LOGOUT",
  LOGOUT_SUCCESS: "USER_LOGOUT_SUCCESS",

  GETALL: "GETALL",
  GETALL_REQUEST: "USERS_GETALL_REQUEST",
  GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  GETALL_FAILURE: "USERS_GETALL_FAILURE",

  HISTORY: "HISTORY"
};
